import apiService from './apiService';
import { GET } from './executer';

interface MetadataResponse {
  success: boolean;
  timestamps: Record<string, string | null>;
}

class MetadataService {
  async getLastUpdated(collections: string[]): Promise<Record<string, string | null>> {
    const response = await apiService.client.execute<MetadataResponse>(
      GET,
      `/api/metadata/last-updated?collections=${collections.join(',')}`
    );

    if (response.data?.success) {
      return response.data.timestamps;
    }

    return {};
  }
}

const metadataService = new MetadataService();
export default metadataService;
